import React from 'react';
import { ContentWrapper, Header, PopupContent, PopupTextBlock, Subtext } from '../Popups.styles';

const ConfirmContent = ({ main, subText, iconPath }) => {
  // Needed to handle multiple lines
  let subTextArray;
  if (subText) {
    subTextArray = subText.map((text) => {
      return <Subtext key={text}>{text}</Subtext>;
    });
  }

  return (
    <ContentWrapper>
      <PopupContent width={'262px'}>
        <PopupTextBlock>
          <Header>{main}</Header>
        </PopupTextBlock>
        <PopupTextBlock>{subTextArray}</PopupTextBlock>
      </PopupContent>
    </ContentWrapper>
  );
};

export default ConfirmContent;
